import { Scene } from "./View3dScene";
import * as THREE from "three";

/* statsUtils
 * 3D環境および形状情報の取得.
 * 主に開発用.
 */
export class stats3D {
	public nTotal: number;
	public nMeshes: number;
	public nGeometries: number;
	public geometryNames: string[];
	public nBufferGeometries: number;
	public mapBufferGeometries: any;
	public nUniqueBufferGeometries: number;
	public nPolygons: number;
	public nVertices: number;
	public nTextures: number;
	public nUniqueTextures: number;
	public textureNames: string[];
	public mapTextures: any;
	public nCubeTextures: number;
	public nUniqueCubeTextures: number;
	public mapCubeTextures: any;
	public nLights: number;
	public lightNames: string[];
	public nLightAmbients: number;
	public nLightDirectionals: number;
	public nLightPoints: number;
	public nLightSpots: number;
	public nCameras: number;
	public cameraNames: string[];
	public nLines: number;
	public nLineSegments: number;
	public nWebGLRenderer: number;
	public nGroups: number;
	public nEmptyMeshes: number;
	public emptyMeshNames: string[];

	constructor() {
		this.nTotal = 0;
		this.nMeshes = 0;
		this.nGeometries = 0;
		this.geometryNames = [];
		this.nBufferGeometries = 0;
		this.mapBufferGeometries = {};
		this.nUniqueBufferGeometries = 0;
		this.nPolygons = 0;
		this.nVertices = 0;
		this.nTextures = 0;
		this.mapTextures = {};
		this.nUniqueTextures = 0;
		this.textureNames = [];
		this.nCubeTextures = 0;
		this.mapCubeTextures = {};
		this.nUniqueCubeTextures = 0;
		this.nLights = 0;
		this.lightNames = [];
		this.nLightAmbients = 0;
		this.nLightDirectionals = 0;
		this.nLightPoints = 0;
		this.nLightSpots = 0;
		this.nCameras = 0;
		this.cameraNames = [];
		this.nLines = 0;
		this.nLineSegments = 0;
		this.nWebGLRenderer = 0;
		this.nGroups = 0;
		this.nEmptyMeshes = 0;
		this.emptyMeshNames = [];
	}
}

/**
 * class: statsUtils
 */
export class statsUtils {

	public static getNameTree(obj: any): string {
		if (obj == undefined) return "";
		let str: string = statsUtils.getNameTree(obj.parent);
		if (obj.objectId != undefined) str = obj.objectId + ":" + str;
		else if (obj.name != undefined) str = obj.name + ":" + str;
		return str;
	}

	public static getMaterialStats(mat: THREE.Material, stats: stats3D, depth: number) {
		if (mat.name) {
			let name = "";
			for (var i = 0; i < depth; i++) name = name + "-";
			name = name + mat.name;
			console.log(name);
		}

		if(Array.isArray(mat)) {
			let multi = mat;
			if (multi != undefined) {
				for (var m = 0; m < multi.length; m++) {
					statsUtils.getMaterialStats(multi[m], stats, depth + 1);
				}
			}
		}
		else if (mat instanceof THREE.MeshBasicMaterial) {
			let basic = <THREE.MeshBasicMaterial>(mat);
			if (basic.map != undefined) {
				stats.nTextures++;
				stats.mapTextures[basic.map.id] = mat.name + ":" + basic.map.id;
			}
			else if (basic.envMap != undefined) {
				stats.nCubeTextures++;
				stats.mapCubeTextures[basic.envMap.id] = 0;
			}
		}
		else if (mat instanceof THREE.MeshLambertMaterial) {
			let lambert = <THREE.MeshLambertMaterial>(mat);
			if (lambert.map != undefined) {
				stats.nTextures++;
				stats.mapTextures[lambert.map.id] = mat.name + ":" + lambert.map.id;
			}
			else if (lambert.envMap != undefined) {
				stats.nCubeTextures++;
				stats.mapCubeTextures[lambert.envMap.id] = 0;
			}
		}
		else if (mat instanceof THREE.MeshPhongMaterial) {
			let phong = <THREE.MeshPhongMaterial>(mat);
			if (phong.map != undefined) {
				stats.nTextures++;
				stats.mapTextures[phong.map.id] = mat.name + ":" + phong.map.id;
			}
			else if (phong.envMap != undefined) {
				stats.nCubeTextures++;
				stats.mapCubeTextures[phong.envMap.id] = 0;
			}
		}
		else if (mat instanceof THREE.MeshStandardMaterial) {
			let standard = <THREE.MeshStandardMaterial>(mat);
			if (standard.map != undefined) {
				stats.nTextures++;
				stats.mapTextures[standard.map.id] = mat.name + ":" + standard.map.id;
			}
			else if (standard.envMap != undefined) {
				stats.nCubeTextures++;
				stats.mapCubeTextures[standard.envMap.id] = 0;
			}
		}
	}

	// 呼び出し元がdeveloperのみなので、コメントアウト
	public static getObjectStats(obj: THREE.Object3D, stats: stats3D) {

	}

	public static getSceneStats(scene: Scene): stats3D {
		let stats: stats3D = new stats3D();
		scene.me.traverse(function (child) {
			statsUtils.getObjectStats(child, stats);
		});
		for (var key in stats.mapTextures) {
			stats.nUniqueTextures++;
			stats.textureNames.push(stats.mapTextures[key]);
		}
		for (var key in stats.mapCubeTextures) stats.nUniqueCubeTextures++;
		for (var key in stats.mapBufferGeometries) stats.nUniqueBufferGeometries++;
		return stats;
	}
}
